import { getExactKeyPath, setKeyPath } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { useCallback, useContext, useEffect } from 'react';
import getIn from 'transmute/getIn';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { useEditorActions } from './useEditorActions';
export const useNullAssociationState = (logicGroup, conditionPath) => {
  const {
    nullValueState,
    internalDraftValue,
    dispatch
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onChangeInternal
  } = useEditorActions();
  const branchHashKey = conditionPath.join('__');
  useEffect(() => {
    const newNullValueState = Object.assign({}, nullValueState);
    const cachedShowIncludeObjectsWithNoAssociatedObjects = nullValueState.showIncludeObjectsWithNoAssociatedObjectsByFilterBranch[branchHashKey];
    if (cachedShowIncludeObjectsWithNoAssociatedObjects === undefined) {
      newNullValueState.showIncludeObjectsWithNoAssociatedObjectsByFilterBranch = Object.assign({}, newNullValueState.showIncludeObjectsWithNoAssociatedObjectsByFilterBranch, {
        [branchHashKey]: getIn(['includeObjectsWithNoAssociatedObjects'], logicGroup)
      });
      dispatch({
        type: 'nullValueState',
        payload: newNullValueState
      });
    }
  }, [conditionPath, logicGroup, dispatch, nullValueState, branchHashKey]);
  const onCheckboxChange = useCallback(evt => {
    const filterGroup = getExactKeyPath(conditionPath, internalDraftValue).set('includeObjectsWithNoAssociatedObjects', evt.target.checked);
    const newInternalDraftValue = setKeyPath(conditionPath, filterGroup, internalDraftValue);
    onChangeInternal(newInternalDraftValue);
  }, [conditionPath, internalDraftValue, onChangeInternal]);
  return {
    showNullAssociationCheckbox: nullValueState.showIncludeObjectsWithNoAssociatedObjectsByFilterBranch[branchHashKey],
    onCheckboxChange
  };
};